/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyRules } from '../../models/company-rules';

export interface GetCompanyEmployeeAccessRules$Json$Params {
  companyId: string;
}

export function getCompanyEmployeeAccessRules$Json(http: HttpClient, rootUrl: string, params: GetCompanyEmployeeAccessRules$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyRules>> {
  const rb = new RequestBuilder(rootUrl, getCompanyEmployeeAccessRules$Json.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyRules>;
    })
  );
}

getCompanyEmployeeAccessRules$Json.PATH = '/company/{companyId}/rules';
